<script>
	// Stores
	import SportEventStore from '@/Stores/Sport/SportEventStore.js';
	// Components
	import Modal from '@/Components/ModalFlex.svelte';
	import LoadingButton from '@/Components/LoadingButton.svelte';
	import TextAreaInput from '@/Components/TextAreaInput.svelte';
	// Services
	import { notify } from '@/Services/Notify.js';

	export let open = false;
	export let user;
	export let onSave;
	export let event;

	let sending = false;

	function confirmClicked() {
		sending = true;
		SportEventStore.updateNote(event.id, event.note)
			.then(() => {
				notify({
					type: 'success',
					title: event.name,
					message: 'Note updated for event',
					timeout: 3
				});
				open = false;
			})
			.catch((e) => {
				notify({
					type: 'danger',
					title: 'Error!',
					message: (e.error && e.error[0]) || 'Failed to Update note',
					timeout: 5
				});
			})
			.finally(() => (sending = false));
	}
</script>

{#if open}
	<Modal on:close={() => (open = false)}>
		<h2 slot="header" class="pt-2 text-xl font-bold text-center">Add Note</h2>
		<div class="flex flex-col w-full px-4 pt-2 text-center">
			<TextAreaInput
				name="note"
				className="pb-4 w-full"
				bind:value={event.note}
				required={true}
				placeholder="Description"
			/>
			<LoadingButton on:click={confirmClicked} loading={sending} className="mb-4 btn btn-primary">Save</LoadingButton>
			<button class="mb-4 btn btn-muted" on:click={() => (open = false)}> Cancel </button>
		</div>
	</Modal>
{/if}
